import { useState, ChangeEvent, useEffect } from "react";
import styled from "styled-components";
import { Edit, Trash } from "../../../public/assets";
import { HorizontalLine } from "./CreatePaymentLink.styles";
import {
  DeletePaymentLink,
  EditPaymentLink,
} from "../../graphql/mutations/paymentlink";
import { useQuery, useMutation } from "@apollo/client";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";
import { GET_ALL_PRODUCTS } from "../../graphql/queries/paymentlink";
import { getData } from "../../utils/localStorage";
import { environment } from "../../env";
import AddNewProductModal from "../../components/AddNewProduct/AddNewProduct.Component";
import { useDispatch } from "react-redux";
import { deleteSelectedProduct } from "../../store/products/productSlice";

const CreateCardContainer = styled.div`
  border: 1px solid rgb(232, 234, 237);
  border-radius: 12px;
`;

const CreateCardInnerContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding-bottom: 30px;
`;

const CreateCardImageContainer = styled.div`
  display: flex;
`;

const CreateCardImage = styled.div`
  padding-top: 10px;
  width: 70px;
  display: flex;
  margin-left: 10px;
`;

const ProductImage = styled.img`
  width: 70px;
  height: 70px;
`;

const CreateCardTitle = styled.h1`
  font-size: 14px;
  font-weight: 500;
  white-space: pre;
`;

const CreateCardPrice = styled.span`
  font-family: "Inter";
  font-size: 14px;
  font-weight: 400;
`;

const CreateCardQuantity = styled.span`
  font-size: 14px;
  font-weight: 400;
`;

const CreateCardInputField = styled.input`
  width: 10%;
  border: 1px solid #e8eaed;
  min-width: 40px;
  padding: 10px;
`;

const CreateCardMapped = styled.div`
  padding: 10px 0px 10px 0px;
  font-size: 14px;
  font-weight: 500;
  color: #363636;
`;

const CreateCardLabel = styled.label`
  display: flex;
  align-items: center;
  margin-left: 5px;
`;

const CreateCardBetween = styled.div<{ show: boolean }>`
  width: 80%;
  margin: 0 auto;
  display: ${(props) => (props.show ? "block" : "none")};
  cursor: pointer; /* Add cursor pointer */
`;

const CreateCardSpan = styled.span`
  margin-right: 10px;
`;

const CreateCardSpan1 = styled.span`
  margin-left: 10px;
  margin-right: 10px;
`;

const CreateCardIconsContainer = styled.div`
  img {
    display: flex;
    padding-top: 10px;
    margin-right: 20px;
  }
`;

const CheckBox = styled.input`
  width: 16px;
  height: 16px;
  padding-right: 5px;
  display: inline-flex;
  padding-top: 2px;
  justify-content: center;
  align-items: center;
  appearance: none;
  border: 2px solid ${(props) => (props.checked ? "#00A603" : "#ccc")};
  border-radius: 4px;
  outline: none;
  position: relative;

  &:checked {
    background-color: #ccf4cd;
    border-color: #00a603;
  }

  &:checked::before {
    content: "";
    width: 40%;
    height: 50%;
    border: solid #00a603;
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-45%, -60%) rotate(45deg);
  }
`;

interface PaymentCardData {
  id: string;
  images: string;
  name: string;
  price: number;
  quantity: number;
  from: number;
  to: number;
}

interface CreatePaymentCardProps {
  data: PaymentCardData;
}

interface Product {
  id: string;
  price: number;
  name: string;
  description: string;
  organizationId: string;
  images: string;
}

const CreatePaymentCard: React.FC<CreatePaymentCardProps> = ({ data }) => {
  const [checkedValues, setCheckedValues] = useState<string[]>([]);
  const [showModal, setShowModal] = useState(false);
  const [editItemId, setEditItemId] = useState("");
  const [products, setProducts] = useState<Product[]>([]);
  const [paymentData, setPaymentData] = useState<PaymentCardData>(data);
  const [updateProduct] = useMutation(EditPaymentLink, {
    variables: { ...environment.paymentLinkService },
  });
  const [isDeleted, setIsDeleted] = useState<boolean>(false);
  const {
    loading,
    error,
    data: queryData,
  } = useQuery(GET_ALL_PRODUCTS, {
    variables: { ...environment.paymentLinkService },
  });
  const dispatch = useDispatch();
  const [showBetween, setShowBetween] = useState(false);
  const [isEdit, setIsEdit] = useState("edit");
  const [deleteProduct] = useMutation(DeletePaymentLink, {
    variables: { ...environment.paymentLinkService },
  });
  const navigate = useNavigate();

  // console.log("this is a edit data ", queryData);

  const handleEdit = (id: any) => {
    setIsEdit("edit");
    setEditItemId(id);
    setShowModal(!showModal);
  };

  // const handleEdit = (id: any) => {
  //   navigate("/dashboard/add-new-product", {
  //     state: { isEdit: "edit", id: id },
  //   });
  // };

  const closeModal = () => {
    setShowModal(false);
    // setEditItemId(null);
  };

  // const updateProducts = (product: Product) => {
  //   setProducts([...products, product]); // Update products state with new product
  // };

  const LinkOptions = [
    { label: "Let customers adjust quantity", value: "adjustquantity" },
  ];

  const handleCheck = (e: ChangeEvent<HTMLInputElement>) => {
    const { value, checked } = e.target;

    if (checked) {
      setCheckedValues((prevValues) => [...prevValues, value]);
      setShowBetween(true);
    } else {
      setCheckedValues((prevValues) =>
        prevValues.filter((val) => val !== value)
      );
      setPaymentData({ ...paymentData, from: 0, to: 99 });
    }
  };

  useEffect(() => {
    console.log("Payment Data updated:", paymentData);
  }, [paymentData]);

  const handleDelete = async (id: string) => {
    setIsDeleted(true);
    dispatch(deleteSelectedProduct(id));
  };

  return (
    <CreateCardContainer>
      <ToastContainer />
      {!isDeleted && (
        <>
          <CreateCardInnerContainer>
            {showModal && (
              <AddNewProductModal
                onClose={closeModal}
                isEdit={isEdit}
                editItemId={editItemId}
              />
            )}
            <CreateCardImageContainer>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <CreateCardImage>
                  <ProductImage src={data.images} alt="" />
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      paddingLeft: "10px",
                    }}
                  >
                    <CreateCardTitle>{data.name}</CreateCardTitle>
                    <CreateCardPrice>${data.price}</CreateCardPrice>
                    <div>
                      <CreateCardQuantity>
                        Quantity:{" "}
                        <CreateCardInputField
                          type="text"
                          value={data.quantity}
                          readOnly
                        />
                      </CreateCardQuantity>
                    </div>
                  </div>
                </CreateCardImage>
                <div>
                  <CreateCardMapped>
                    {LinkOptions.map((option) => (
                      <CreateCardLabel key={option.value}>
                        <CheckBox
                          type="checkbox"
                          name="linkOption"
                          value={option.value}
                          checked={checkedValues.includes(option.value)}
                          onChange={handleCheck}
                        />
                        {option.label}
                      </CreateCardLabel>
                    ))}
                  </CreateCardMapped>
                  <CreateCardBetween
                    show={showBetween}
                    onClick={() => setShowBetween(false)}
                  >
                    <CreateCardSpan>Between</CreateCardSpan>
                    <CreateCardInputField
                      type="text"
                      value={data.from}
                      onChange={(e) =>
                        setPaymentData({
                          ...paymentData,
                          from: parseInt(e.target.value),
                        })
                      }
                    />

                    <CreateCardSpan1>and</CreateCardSpan1>
                    <CreateCardInputField
                      type="text"
                      value={data.to}
                      onChange={(e) =>
                        setPaymentData({
                          ...paymentData,
                          to: parseInt(e.target.value),
                        })
                      }
                    />
                  </CreateCardBetween>
                </div>
              </div>
            </CreateCardImageContainer>
            <div style={{ display: "flex" }}>
              <CreateCardIconsContainer>
                <img
                  onClick={() => handleEdit(data.id)}
                  src="/assets/svg/edit-2.svg"
                  alt=""
                />
              </CreateCardIconsContainer>

              <CreateCardIconsContainer>
                <img
                  onClick={() => handleDelete(data.id)}
                  src="/assets/svg/trash.svg"
                  alt=""
                />
              </CreateCardIconsContainer>
            </div>
          </CreateCardInnerContainer>
          <HorizontalLine />
        </>
      )}
      {/* {showModal && (<AddNewProductModal/>)} */}
    </CreateCardContainer>
  );
};

export default CreatePaymentCard;
